import React, { Component } from 'react';
import { Row, Col,Button  } from 'antd';
import { Drawer , Badge, Tabs } from 'antd';
import { Link } from 'react-router-dom';
import {burritoAPIs} from '../../apiCalls/index'
import $ from "jquery";
import { find ,sum, findIndex } from 'lodash';

const { TabPane } = Tabs;

var arrExtra = [];
var orderdetails  = {'orderdetails':[]};

var extraCount = 0;
var extraItemCount = 1;


class Menu extends Component {
    state = { 
   
    };
   constructor(props){ 
    super(props);
    this.state = {
        visible: false,
        placement: 'bottom',
        menu: [],
        menuDeal: [],
        itemDetailsObj:[],
        selectedItemPrice:'',
        orderCount:0,
        extraAddedFlag:false,
        xTrue:false,
        exArray:[]
        
    }
  }

   componentDidMount(){ 
     console.log('Hello')
    burritoAPIs.getMenu().then((responsevar) => {
      console.log('All responsevar', responsevar.menus);
      this.setState({
          menu:responsevar.menus
      })
  }).catch((errorMsg) => {
      console.log(errorMsg);
  });

    burritoAPIs.getSpecialDeal().then((specialDeal) => {
        console.log('All specialDeal', specialDeal.specialdeals);
        this.setState({
          menuDeal:specialDeal.specialdeals
      })
    }).catch((errorMsg) => {
        console.log(errorMsg);
    });
    }

    showDeals(){

      }

  incrementValue(e,incPrice) { 

    var fieldName = $(e.target).data('field');
    var parent = $(e.target).closest('div');
    var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
  
    if (!isNaN(currentVal)) {
      parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
    } else {
      parent.find('input[name=' + fieldName + ']').val(0);
    }
    let valInc = $('.selectedItemPrice').val();
    $('.selectedItemPrice').val(Number(valInc) + Number(incPrice))
  }
  
   decrementValue(e,decPrice) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).closest('div');
    var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
  
    if (!isNaN(currentVal) && currentVal > 0) {
      parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
    } else {
      parent.find('input[name=' + fieldName + ']').val(0);
    }
   
    let valInc = $('.selectedItemPrice').val();
    if(Number(valInc) > 0) {
      $('.selectedItemPrice').val(Number(valInc) - Number(decPrice))
    }

    let valQuantity =  $('.valQuantity').val();
    if(Number(valQuantity) == 0){
      extraCount = 0;
      let valInc = $('.selectedItemPrice').val();
      $('.selectedItemPrice').val(0);
    }
    
  }

    showDrawer () {
        console.log('im drawer')
        this.setState({
          visible: true,
        });
      };
    
      onClose () {
        extraCount = 0;
        arrExtra.length = 0;
        const { itemDetailsObj } = this.state;
        itemDetailsObj.extras.length =  0 

        this.setState({
          visible: false,       
        });
        
        console.log('AFTER',this.state.itemDetailsObj)
      };
    
      onChange = e => {
        this.setState({
          placement: e.target.value,
        });
      }; 

   

    itemDetails(itemID){
      burritoAPIs.getItemDetails(itemID).then((responsevar) => {
        console.log('All itemDetails', responsevar.item);
        this.setState({
        itemDetailsObj:responsevar.item,
        selectedItemPrice:responsevar.item.price,
         visible: true,
        });
        console.log('All itemDetailsObj', this.state.itemDetailsObj);
    }).catch((errorMsg) => {
        console.log(errorMsg);
    });

    }  


    addExtras(id,price,name){ 
   
      const { itemDetailsObj , extraLocal } = this.state;
      var getItemIndex = findIndex(itemDetailsObj.extras, ['_id', id]);
      itemDetailsObj.extras[getItemIndex].count =  extraItemCount++;    
      

      console.log('arrExtra',arrExtra);
      var isExtra = find(arrExtra, ['extraItemId',id]);
      if(!isExtra){
        console.log('in first')
      extraCount = 1
      itemDetailsObj.extras[getItemIndex].count = 1
      document.getElementById(id+123).style.display = 'inline'
      document.getElementById(id).innerHTML =  extraCount
      arrExtra.push({'extraItemId':id,
      'extraItemName':name,
      'count':extraCount,
      'totalPrice':price
       });
        let valQuantity =  $('.valQuantity').val();
        if(Number(valQuantity) > 0){
          let valInc = $('.selectedItemPrice').val();
          $('.selectedItemPrice').val(Number(valInc) + Number(price))
        }
       }
       else if(isExtra){
         
        console.log('in second')
        itemDetailsObj.extras[getItemIndex].count = ++extraCount;
        var getIndex = findIndex(arrExtra, ['extraItemId', id]); 
        console.log('getIndex',getIndex)
        document.getElementById(id+123).style.display = 'inline'
        document.getElementById(id).innerHTML = arrExtra[getIndex].count + 1 
        arrExtra[getIndex].count = arrExtra[getIndex].count + 1
        // arrExtra.push({'extraItemId':id,
        // 'extraItemName':name,
        // 'count':extraCount++
        //  });
          let valQuantity =  $('.valQuantity').val();
          if(Number(valQuantity) > 0){
            let valInc = $('.selectedItemPrice').val();
            $('.selectedItemPrice').val(Number(valInc) + Number(price))
          }
         }
         console.log('itemDetailsObj',itemDetailsObj);
    }

    saveOrderDeal(selectedItemID,selectedItemName, oneUnitPrice){
      console.log('arrExtra',arrExtra)
      var item = {
        "item" : {
            "itemId" : selectedItemID,
            "itemName": selectedItemName,
            "quantity" : 1,
            "price": oneUnitPrice,
            "extras" : arrExtra,
            "oneUnitPrice": oneUnitPrice,
            "itemOrderId":Math.floor((Math.random() * 1000000) + 1)
     }
     }
     orderdetails.orderdetails.push(item);
     console.log('orderdetails',orderdetails)
     this.setState({
      orderCount: this.state.orderCount + 1,
      visible: false,
     })
    //  var countArray = []
    //  for (var i=0; i < orderdetails.orderdetails.length; i++) {
    //   countArray.push(Number(orderdetails.orderdetails[i].item.price))        
    //  }
    // orderdetails.price = sum(countArray)
     localStorage.setItem("orderDetailsLocalObj", JSON.stringify(orderdetails));
     arrExtra = [];
     extraCount = 0;
    }

    saveOrder(selectedItemID,selectedItemName, oneUnitPrice){
    console.log('arrExtra',arrExtra)
    var item = {
      "item" : {
          "itemId" : selectedItemID,
          "itemName": selectedItemName,
          "quantity" : $('.valQuantity').val(),
          "price": $('.selectedItemPrice').val(),
          "extras" :arrExtra,
          "oneUnitPrice": oneUnitPrice,
          "itemOrderId":Math.floor((Math.random() * 1000000) + 1)
   }
   }
   orderdetails.orderdetails.push(item);
   console.log('orderdetails',orderdetails)
   this.setState({
    orderCount: this.state.orderCount + 1,
    visible: false,
   })
  //  var countArray = []
  //  for (var i=0; i < orderdetails.orderdetails.length; i++) {
  //   countArray.push(Number(orderdetails.orderdetails[i].item.price))        
  //  }
  // orderdetails.price = sum(countArray)
   localStorage.setItem("orderDetailsLocalObj", JSON.stringify(orderdetails));
   arrExtra = [];
   extraCount = 0;
  }

  gotoMyOrder(){
    extraCount = 0;
    var isTrueMyOrderArray = JSON.parse(localStorage.getItem("orderDetailsLocalObj") || "[]");
    if(isTrueMyOrderArray.orderdetails.length > 0){
      this.props.history.push({
        pathname: '/myorder'              
    });
    }
  }
  excludeItem(exItemName,exIngredientName){
  const { exArray } = this.state
  var exContent ={
    exItemName:exItemName,
    exIngredientName:exIngredientName
  }
  exArray.push(exContent)
  console.log('exArray',exArray)
  localStorage.setItem("excludeItems", JSON.stringify(exArray));
  document.getElementById(exIngredientName).style.display = 'none'
  }
    render() { 
    const{ menu , menuDeal ,itemDetailsObj , selectedItemPrice , orderCount , extraLocal , xTrue} = this.state ;
    console.log(menu)
    const resume = menu.map((info, i) => {
      return (
        <div className='menu-row'>
        <div className='menu-title'>
        {info.name}
        {console.log(info.items)}
          </div>          
          {info.items.map((experience, idx) =>
          <Row gutter={16} style={{marginBottom:'15px'}}>
          <Col span={13}>
          <div className='item-name'>{experience.name}</div>
          <div className='item-para'>
          {experience.ingredient.map((ingredients, idx) =>
          <span>{ingredients.name+", "}</span>
          )}
         </div>
          </Col> 
          <Col span={2}>
          </Col> 
          <Col span={7}>
          <div className='item-name'>$ {experience.price}</div>
          </Col> 
          <Col span={2}>
          <i onClick={() => this.itemDetails(experience._id)} className='fa fa-plus add-item'></i>
          </Col>    
          </Row> 
          )}            
        </div>
      )
    });

        return ( 
            <React.Fragment>
               <div className='menu-page'>
               <span className='scroll-btn'>
                       <i className='fa fa-arrow-down'></i>
                       <span>Scroll</span>
                       <i className='fa fa-arrow-down'></i>
                   </span>
               <div className='menu-static-upper'>
               <Link to='/home'>
                   <span className='home-ico'>
                   <i className='fa fa-home'></i>
                   </span>
                   </Link>
                
                   <div className='menu-head'>Burrito Bar</div>
                   <div style={{textAlign:'center',marginTop:'60px'}}>
                   <Button className='round-orange-btn'>
                   Menu
                   </Button>
                    
                   <Button 
                   onClick={() => this.gotoMyOrder()} 
                   style={{position:'relative'}}                                      
                   className='round-white-btn'>
                   <Badge className='orderCount' count={orderCount} />
                   My Order
                   </Button>  
                   </div>
                   </div>

        <div className='menu-btm'>  
        <Tabs defaultActiveKey="1">
    <TabPane tab="Deals" key="1">
    <div className='menu-row'>
        <div className='menu-title'>
        Special Deals
        
          </div>          
          {menuDeal.map((experienceDeal, idx) =>
          <Row gutter={16} style={{marginBottom:'15px'}}>
          <Col span={13}>
          <div className='item-para'>
          {experienceDeal.items.map((ingredientsDeal, idx) =>
          <span>{ingredientsDeal.name+", "}</span>
          )}
          </div>
          </Col> 
          <Col span={2}>
          </Col> 
          <Col span={7}>
          <div className='item-name'>$ {experienceDeal.price}</div>
          </Col> 
          <Col span={2}>
          <i 
          onClick={() => this.saveOrderDeal(experienceDeal._id,'specialDeal',experienceDeal.price)}          
          className='fa fa-plus add-item'></i>
          </Col>    
          </Row> 
          )}            
        </div>
    </TabPane>
    <TabPane tab="Menu" key="2">
     
    <div className='menu-row'>
        {resume} 
        </div>
    </TabPane>

  </Tabs>


     

        </div>
                   
               </div> 
               {this.state.visible ? 
        <Drawer         
          placement={this.state.placement}        
          onClose={() => this.onClose}
          visible={this.state.visible}
          key={this.state.placement}
        >
        <span className='arrow-ico'>
        <i
         onClick={() => this.onClose()} 
        className='fa fa-chevron-down'></i>
        </span>
         <div style={{paddingTop: '25px'}} className='item-name'>Customize Order</div>
         <div className='custom-wind'>
          <Row gutter={16} style={{marginBottom:'15px'}}>
          <Col span={24}>
          <div className='item-name'>{itemDetailsObj.name}</div>
          <div className='item-para'>
          {itemDetailsObj.ingredients.map((itemIngredients, idx) =>
          <div id={itemIngredients.name}>
             <span>{itemIngredients.name}</span>
             <span> <i
           onClick={() => this.excludeItem(itemDetailsObj.name,itemIngredients.name)}
          style={{fontSize:'11px',paddingTop:'3px'}} className='fa fa-close add-item'></i></span>
          </div>
         
          )}
         </div>
          </Col>    
          </Row>
          {itemDetailsObj.extras.map((itemExtras, idx) =>
          <Row>
          <Col span={19}>
          <div className='light-font'>
          <span className='dot'>
          <img height='' width='' src={require('../../assets/img/dot.png')}/> 
          </span>
          {itemExtras.name}
          <span id={itemExtras._id+123} style={{paddingLeft:'10px',display:'none'}}>x</span>
          <span id={itemExtras._id}> </span>
             
          </div>
          </Col> 
          <Col span={3}>
          <div style={{fontSize:'11px'}} className='item-name'>$ {itemExtras.price}</div>
          </Col> 
          <Col span={2}>
          <i
           onClick={() => this.addExtras(itemExtras._id,itemExtras.price,itemExtras.name)}
          style={{fontSize:'11px',paddingTop:'3px'}} className='fa fa-plus add-item'></i>
          </Col> 
          </Row>
          )}

                    
         </div>

         <div>   
             <div class="counter">
             <Row gutter={16} style={{margin:'15px 0'}}>
             <Col span={2}></Col>
             <Col className='label-cus' style={{display:'grid',justifyContent:'right'}} span={7}>
             Quantity:
             </Col>
             <Col span={12}>   
             <div class="counter">          
             <input type="number" step="1" max="" min="1" value="1" name="quantity" class="bg-input-menu valQuantity"/>
           
            
             {/* <span>
             <i
            onClick={(e) => {
            this.incrementValue(e,selectedItemPrice)
            }}
             className='fa fa-plus plus-draw button-plus' data-field="quantity"></i>
             </span>

             <span>
             <i
              onClick={(e) => {
              this.decrementValue(e,selectedItemPrice)
              }}
             className='fa fa-minus minus-draw button-minus' data-field="quantity"></i>
             </span> */}
            </div>
             </Col>
             <Col span={3}></Col>
             </Row>
             </div>

             <Row gutter={16} style={{margin:'15px 0'}}>
             <Col span={2}></Col>
             <Col className='label-cus' style={{display:'grid',justifyContent:'right'}} span={7}>
             Price:
             </Col>
             <Col span={6}>
             {/* <div className='bg-input selectedItemPrice'>$ {selectedItemPrice}</div> */}
             <input value={Number(selectedItemPrice).toFixed(2)} class="bg-input-menu selectedItemPrice"/>
             </Col>
             <Col span={6}></Col>
             <Col span={3}></Col>
             </Row>
         </div>
         <div className='btn-drawer' style={{textAlign:'center',marginTop:'20px'}}>
         <Row style={{display:'flex', justifyContent:'space-around'}}>
           <Col span={10}>
            <Button
              onClick={() => this.onClose()}                                                    
              className='round-white-btn' style={{width:'100%', margin:'0'}}>
              Cancel
            </Button> 
           </Col>
           <Col span={10}>
            <Button 
              onClick={() => this.saveOrder(itemDetailsObj._id,itemDetailsObj.name,itemDetailsObj.price)}
              className='round-orange-btn' style={{width:'100%', margin:'0'}}>
              Add
            </Button>
           </Col>
         </Row>
          
         
          
    
          </div>
        </Drawer>
                
                : ''}
               
         
            </React.Fragment>
         );
    }
}
 
export default Menu;